import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';

@Injectable({ providedIn: 'root' })
export class TimeoutIntervalService {

    private readonly _buffer: number = 10000; // 10sec

    constructor(private config: AppConfig) { }

    /**
     *  Returns value (in milliseconds) that is used when evaluating whether request has
     *  timeouted, since timeout cannot be inferred from response statuscode (0) in browser. 
     *  NOTE: using buffer since value must be sufficiently shorter than proxy timeout to catch all timeouts.
     */
    public getTimeoutInterval() {

        let value;

        if (this.config.backendIwmUri.startsWith("http://localhost")) {
            value = 120000; // When running backend in local environment, Service Fabric timeout (120sec) is used. 
        }
        else {
            value = 100000; // Cloudflare proxy timeout is 100sec.
        }
        return value - this._buffer;
    }
}
